import React, { useState, useEffect } from "react";
import CheckBox from "../CheckBox/CheckBox";
import "./CheckBoxLabel.css";
import "../Styles/SvgCommand.css";
import SortCommand from "../SortCommand/SortCommand";
import SearchIcon from "../SearchIcon/SearchIcon";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function CheckBoxLabel(props) {
  const [isDragOver, setDragover] = useState(false);
  const [checked, setChecked] = useState(false);
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const buildStyle = useBuildStyle();

  useEffect(() => {
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  const getStyle = () => {
    var newStyle = buildStyle(props.style);

    newStyle["border"] = isDragOver ? "1px dashed #1f79e1" : props.style.border.value;
    return newStyle;
  };

  const onDropColumn = (e) => {
    e.stopPropagation();
    props.onDropColumn(e, props.data);
    setDragover(false);
  };

  const onDrag = (e, dragOver) => {
    if (dragOver !== isDragOver)
      setDragover(dragOver);
   
  };

  const getInputWidth = () => {
    var inputWidth = props.style.width.value;
    const iconWidth = 13;
    if (props.sortable) {
      
      inputWidth = parseInt(inputWidth.slice(0, -2)) - iconWidth + "px";
    }

    if (props.filterable) {
      inputWidth = parseInt(inputWidth.slice(0, -2)) - iconWidth + "px";
    }

    return inputWidth;
  };

  return (
    <div
      draggable={props.draggable}
      onDragStart={(e) => props.onDragStart(e)}
      onClick={props.onClick}
      style={getStyle()}
      id={props.data.id}
      onDrop={(e) => props.onlyLabel && onDropColumn(e)}
      onDragOver={(e) => props.onlyLabel && onDrag(e, true)}
      onDragLeave={(e) => props.onlyLabel && onDrag(e, false)}
      
    >
      {(props.onlyLabel || !props.dataGridColumn) && (
        <div
          className="label"
          style={{
            position: "relative",

            userSelect: "none",
            fontSize: props.style.fontSize.value,
            fontFamily: props.style.fontFamily.value,
            color: props.style.color.value,
          }}
        >
          {props.data.properties.text.value}
        </div>
      )}
      {props.onlyLabel ? (
        props.sortable && <SortCommand />
      ) : (
        <React.Fragment>
          <div style={{paddingLeft: props.filterable ? "13px" : "0px", marginLeft: "auto",marginRight: "auto", boxSizing: "border-box"}}>
            <CheckBox checked={checked} click={() => {setChecked(!checked); props.onChange(!checked)}} />
          </div> 
          {props.filterable && <SearchIcon className= "svgSearchIcon" onClick = {(e) => props.onClickSearchIcon(e)} id = {"Filter" + props.data.id} width="13px" />}
        </React.Fragment>
      )}

      
    </div>
  );
}
